import { useState, useEffect } from 'react';

export const useVehicleHistoryAutoFill = (form, vehicleHistory, updateForm) => {
    const [vehicleInfo, setVehicleInfo] = useState(null);

    useEffect(() => {
        if (form.vin && form.vin.length >= 5 && vehicleHistory.length > 0) {
            const vehicleData = vehicleHistory.find(
                (v) => v.vin && v.vin.toLowerCase().includes(form.vin.toLowerCase())
            );

            if (vehicleData) {
                setVehicleInfo(vehicleData);

                const updates = {};
                if (vehicleData.model && vehicleData.model !== form.model)
                    updates.model = vehicleData.model;
                if (vehicleData.unit && vehicleData.unit !== form.unit)
                    updates.unit = vehicleData.unit;
                if (vehicleData.plates && vehicleData.plates !== form.plates)
                    updates.plates = vehicleData.plates;
                if (vehicleData.engine && vehicleData.engine !== form.engine)
                    updates.engine = vehicleData.engine;

                if (Object.keys(updates).length > 0) {
                    updateForm(updates);
                }
            } else {
                setVehicleInfo(null);
            }
        }
    }, [
        form.vin,
        form.model,
        form.unit,
        form.plates,
        form.engine,
        vehicleHistory,
        updateForm,
    ]);

    return vehicleInfo;
};

